document.addEventListener('DOMContentLoaded', function () {
  // 1. Menu mobile
  var menuBtn = document.querySelector('[data-menu-btn]');
  var navDrawer = document.getElementById('ShifaNavDrawer');
  if (menuBtn && navDrawer) {
    menuBtn.addEventListener('click', function () {
      navDrawer.classList.toggle('is-open');
    });
  }

  // 2. Carrousel produit & miniatures
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var track = gal.querySelector('[data-swipe-track]');
    var slides = Array.from(gal.querySelectorAll('[data-swipe-slide]'));
    var thumbs = Array.from(gal.querySelectorAll('[data-thumb]'));

    if (!track || !slides.length) return;

    thumbs.forEach(function (t, idx) {
      t.addEventListener('click', function () {
        if (slides[idx]) {
          track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
        }
        thumbs.forEach(function (el, i) {
          el.classList.toggle('is-active', i === idx);
        });
      });
    });

    track.addEventListener('scroll', function () {
      var w = track.clientWidth || 1;
      var activeIdx = Math.round(track.scrollLeft / w);
      thumbs.forEach(function (el, i) {
        el.classList.toggle('is-active', i === activeIdx);
      });
    }, { passive: true });
  });

  // 3. Sélecteur de Bundles (Offre 1, Offre 2, Offre 3) + Cadeaux Débloqués (Cadenas)
  document.querySelectorAll('[data-bundles]').forEach(function (wrap) {
    if (wrap.dataset.bundleBound === 'true') return;
    wrap.dataset.bundleBound = 'true';

    var sec = wrap.closest('[data-hero-sec]') || document;
    var qtyInput = sec.querySelector('[data-qty-input]');
    var varInput = sec.querySelector('[data-var-input]');
    var btnPrice = sec.querySelector('[data-btn-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var items = Array.from(wrap.querySelectorAll('[data-bundle-item]'));
    var giftSlots = Array.from(sec.querySelectorAll('[data-gift-slot]'));

    function updateGiftsLockState(giftsCount) {
      var unlocked = parseInt(giftsCount || '0', 10);
      giftSlots.forEach(function (slot) {
        var slotIdx = parseInt(slot.getAttribute('data-gift-slot') || '1', 10);
        if (slotIdx <= unlocked) {
          slot.classList.remove('is-locked');
        } else {
          slot.classList.add('is-locked');
        }
      });
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        items.forEach(function (el) {
          el.classList.remove('is-selected');
        });
        item.classList.add('is-selected');

        var q = item.getAttribute('data-qty') || '1';
        var p = item.getAttribute('data-price') || '';
        var v = item.getAttribute('data-variant-id');
        var g = item.getAttribute('data-gifts') || '0';

        if (qtyInput) qtyInput.value = q;
        if (varInput && v) varInput.value = v;
        if (btnPrice && p) btnPrice.textContent = p;
        if (stickyPrice && p) stickyPrice.textContent = p;
        updateGiftsLockState(g);
      });
    });
  });

  // 4. Passage direct au Checkout Shopify (sans passer par le panier)
  document.querySelectorAll('[data-direct-checkout-form]').forEach(function (form) {
    if (form.dataset.checkoutBound === 'true') return;
    form.dataset.checkoutBound = 'true';

    form.addEventListener('submit', function (e) {
      var varInput = form.querySelector('[data-var-input]');
      var qtyInput = form.querySelector('[data-qty-input]');
      var variantId = varInput ? varInput.value : '';
      var qty = qtyInput ? (qtyInput.value || '1') : '1';

      if (variantId) {
        e.preventDefault();
        window.location.href = '/cart/' + encodeURIComponent(variantId) + ':' + encodeURIComponent(qty);
      }
    });
  });

  // 5. Bouton de la barre collante : déclenche aussi le checkout direct
  document.querySelectorAll('[data-sticky-checkout]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var form = document.querySelector('[data-direct-checkout-form]');
      if (form) {
        var varInput = form.querySelector('[data-var-input]');
        var qtyInput = form.querySelector('[data-qty-input]');
        var variantId = varInput ? varInput.value : '';
        var qty = qtyInput ? (qtyInput.value || '1') : '1';
        if (variantId) {
          e.preventDefault();
          window.location.href = '/cart/' + encodeURIComponent(variantId) + ':' + encodeURIComponent(qty);
        }
      }
    });
  });

  // 6. Onglets interactifs Moments de Vie (Section 04)
  document.querySelectorAll('[data-moments-widget]').forEach(function (widget) {
    var tabs = Array.from(widget.querySelectorAll('[data-moment-tab]'));
    var panels = Array.from(widget.querySelectorAll('[data-moment-panel]'));
    tabs.forEach(function (tab, idx) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
        panels.forEach(function (p, i) { p.classList.toggle('is-active', i === idx); });
      });
    });
  });

  // 7. Bouton « Afficher les 10 avis vérifiés » dans la section Avis
  document.querySelectorAll('[data-show-more-reviews]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sec = btn.closest('[data-reviews-section]') || document;
      sec.querySelectorAll('.is-hidden-review').forEach(function (card) {
        card.classList.remove('is-hidden-review');
      });
      btn.style.display = 'none';
    });
  });

  // 8. Animation douce d'apparition au scroll sur les sections (.shifa-reveal)
  var revealItems = document.querySelectorAll('.shifa-reveal');
  if ('IntersectionObserver' in window && revealItems.length) {
    var revObs = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    revealItems.forEach(function (el) { revObs.observe(el); });
  } else {
    revealItems.forEach(function (el) { el.classList.add('is-revealed'); });
  }
});

